const clamp=v=>Math.max(0,Math.min(1,v));
const smooth=v=>{const t=clamp(v);return t*t*(3-2*t);};
const mix=(a,b,t)=>a.map((n,i)=>n+(b[i]-n)*t);
export function dispensePose(time) {
  const t=Math.max(0,time);
  let ball=[0,1.84,.12];
  if(t>=1.25&&t<1.8)ball=mix([0,1.84,.12],[0,.48,.88],clamp((t-1.25)/.55)**2);
  else if(t>=1.8&&t<2.14){
    const u=(t-1.8)/.34;ball=mix([0,.48,.88],[.04,.43,1.18],smooth(u));
    ball[1]+=.075*Math.sin(u*Math.PI)*(1-u);
  }
  else if(t>=2.14&&t<3.2){
    const u=clamp((t-2.14)/1.06);ball=mix([.04,.43,1.18],[.36,.285,1.42],smooth(u));
    ball[1]+=Math.abs(Math.sin(u*Math.PI*2))*Math.exp(-u*4)*.17;
  }else if(t>=3.2)ball=[.36,.285,1.42];
  const impact=Math.max(0,t-1.8);
  return {ball,visible:t>=1.25,finished:t>=3.35,
    recoil:impact<.34?Math.sin(impact*34)*Math.exp(-impact*15)*.014:0,
    knob:-Math.PI*2*smooth((t-.2)/1.15),
    flap:-Math.PI*.5*smooth((t-1.55)/.35)*(1-smooth((t-2.25)/.55)),
    churn:Math.sin(clamp((t-.2)/1.5)*Math.PI),
    roll:t<2.14?0:Math.min(t-2.14,1.06)*4.5};
}

// Short anticipation, a quick shell release, then a soft settling overshoot.
// The final pose is exact so the presentation never fights direct manipulation.
export function revealPose(time,reduced=false){
 const t=Math.max(0,time),finished=t>=(reduced?.15:1.5);
 if(reduced||finished)return {progress:reduced?smooth(t/.15):1,finished,packVisible:!finished,toyVisible:true,toyScale:1,toyOffset:[0,0,0],top:[0,0,0],bottom:[0,0,0],topTilt:0,bottomTilt:0,packScale:1,toyTilt:0,focus:0,tension:0};
 const anticipation=smooth(t/.24),u=Math.max(0,t-.285),pop=1-Math.exp(-u*15),flight=smooth(u/.88),enter=clamp(u/.48);
 const arrival=enter<1?.08+.92*(1-(1-enter)**3):1;
 const bounce=u>.48?Math.sin((u-.48)*13)*Math.exp(-(u-.48)*7)*.09:0;
 const lift=u<.48?.24*(1-enter)+Math.sin(enter*Math.PI)*.27:bounce*1.6;
 const flash=Math.sin(Math.PI*clamp(u/.3))*(1-clamp(u/.3));
 return {progress:smooth(t/1.1),finished:false,packVisible:t<1.23,toyVisible:t>=.285,
  toyScale:arrival+bounce,toyTilt:u>0?Math.sin(u*11)*Math.exp(-u*5)*.12:0,focus:flash,
  toyOffset:[.36*(1-smooth(t/1.1)),lift,1.42*(1-smooth(t/1.1))],
  top:[-1.05*flight,1.9*pop-.92*flight*flight,.28*flight],
  bottom:[1.15*flight,-.78*pop-.38*flight*flight,.42*flight],
  topTilt:-flight*2.1,bottomTilt:flight*1.8,
  tension:Math.sin(t*48)*.025*anticipation*(1-pop),packScale:1-.035*anticipation+.68*pop};
}
